import { Route, Routes } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import Account from "./views/account";
import Login from "./views/login";
import PasswordResetRequest from "./views/password-reset-request";
import PasswordResetAcknowledge from "./views/password-reset-acknowledge";
import Menu from "./views/menu";
import Templates from "./views/templates";
import About from "./views/about";
import PrivacyPolicy from "./views/privacy-policy";
import WorkOrders from "./views/work-orders";
import Invitation from "./views/invitation";
import ApiProvider from "./api/provider";

export default function () {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: "purple"
        }
      }}
    >
      <ApiProvider>
        <Routes>
          <Route path="/" element={<Menu />} />
          <Route path="/about" element={<About />} />
          <Route path="/account" element={<Account />} />
          <Route path="/invitation/:invitationId" element={<Invitation />} />
          <Route path="/login" element={<Login />} />
          <Route path="/passwordreset" element={<PasswordResetRequest />} />
          <Route path="/passwordreset/:passwordResetRequestId" element={<PasswordResetAcknowledge />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/workorders" element={<WorkOrders />} />
        </Routes>
      </ApiProvider>
    </ConfigProvider>
  );
}